import axiosInstance from "../../../axios/axiosInstance";
import useSetNotificationAsRead from "./SetNotificationAsReaded"
import { useContext } from "react";
import { NotificationContext } from "../../../context";
import { useShowAlert } from "../../../hooks/useShowAlert";

const usePendingActions = () => {
  const { showAlert } = useShowAlert();
  const { updateNotification } = useContext(NotificationContext);
  const setNotificationAsRead = useSetNotificationAsRead();

  // The identity check on payNow-approve is against the RENTER's Stripe
  // Identity status, not the owner's — the owner is the one clicking
  // Accept here. There is nothing for the owner's browser to do about a
  // renter's unverified identity beyond knowing payment didn't fire yet;
  // the renter will hit the normal (already-handled) identity flow the
  // next time they open the payment screen themselves.
  const handleAccept = async (request) => {
    try {
      const res = await axiosInstance.put(
        `/transactions/approve/${request.objectId}?payNow=true`,
        {}
      );
      if (res.data?.identityVerificationRequired) {
        showAlert(
          "info",
          "Request approved. The renter must verify their identity before the automatic charge can run — payment is now pending on their end."
        );
      } else {
        showAlert("success", res.data.message);
      }
      setNotificationAsRead(request._id);
      updateNotification(); // update notification list
    } catch (err) {
      showAlert("error", err.response?.data?.error || "Failed to approve request");
    }
  };

  const handleReject = (request) => {
    axiosInstance
      .put(`/transactions/reject/${request.objectId}`, {})
      .then((res) => {
        showAlert("success", res.data.message);
        setNotificationAsRead(request._id);
        updateNotification(); // update notification list
      })
      .catch((err) => {
        showAlert("error", err.response.data.error);
      });
  };

  return { handleAccept, handleReject };
};

export default usePendingActions;
